/*
	bs-ed.js のファイル選択機能を拡張する
*/

import FileSelectView from './FileSelectView'

class FileSelect {
	constructor(fileView, cb) {
		const rootE = document.createElement('div')
		document.body.appendChild(rootE)

		const app = new Vue({
			el: rootE,
			data() {
				return fileView.data
			},
			components: {
				FileSelectView,
			},
			template: `<FileSelectView
				:uid="uid"
				:name="name"
				@input="onInput"
				@fileinput="onFileInput"
				@cancel="destroy"
			/>`,
			methods: {
				onInput(item) {
					cb(item)
					this.destroy()
				},
				onFileInput(file) {
					fileView.addUpload(file)
					this.destroy()
				},
				destroy() {
					this.$destroy()
					this.$nextTick(() => {
						this.$el.parentNode.removeChild(this.$el)
					})
				},
			}
		})
	}
}

export default FileSelect
